/* SMCart: global cart API + full-screen drawer (CART-SPEC v9 Part B). No jQuery, no templating: the drawer markup is
   always re-rendered server-side through the Section Rendering API (sections=cart-drawer) so Liquid and JS never drift.
   API: SMCart.get() / add(items) / change(payload) / update(payload) / remove(key) / refresh() / open() / close()
        SMCart.addOffer({ type: 'sub'|'otp', bags, opener, busyEl })  -> sets the cart to exactly that offer (replace, not stack)
   Events: sm:cart:updated, sm:cart:open, sm:cart:close. One request in flight at a time (queue). */
(() => {
  if (window.SMCart) return;
  const SM = (window.SM = window.SM || {});
  const C = SM.config || {};
  const routes = C.routes || { root: '/', cartJs: '/cart.js', cartAdd: '/cart/add.js', cartChange: '/cart/change.js', cartUpdate: '/cart/update.js' };
  const SECTION = C.cartSection || 'cart-drawer';
  const PLAN_BY_BAGS = { 1: '4w', 2: '8w', 3: '12w' };
  const ATTR_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'ttclid', 'gclid'];
  const track = (name, params) => { try { SM.track && SM.track(name, params || {}); } catch (e) { /* never break the cart */ } };
  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const st = { open: false, opener: null, scrollY: 0, histPushed: false, restoration: null, lastCart: null, busy: 0, toastTimer: null, qtyTimers: {} };

  /* ---------- DOM helpers ---------- */
  const drawer = () => document.querySelector('[data-sm-cart-drawer]');
  const panel = () => { const d = drawer(); return d && d.querySelector('[data-sm-cart-panel]'); };
  const pageWrap = () => document.getElementById('SmPageWrap');

  const updateCount = (n) => {
    document.querySelectorAll('[data-sm-cart-count]').forEach((el) => { el.textContent = n; el.dataset.count = n; });
  };

  /* ---------- request queue ---------- */
  let chain = Promise.resolve();
  const enqueue = (fn) => { const p = chain.then(fn, fn); chain = p.catch(() => {}); return p; };

  async function request(url, body) {
    const res = await fetch(url, {
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: body ? JSON.stringify(body) : undefined,
    });
    let data = null;
    try { data = await res.json(); } catch (e) { data = null; }
    if (!res.ok) {
      const err = new Error((data && (data.description || data.message)) || res.statusText || 'Request failed');
      err.status = res.status; err.data = data;
      throw err;
    }
    return data;
  }
  const withSections = (body) => Object.assign({}, body, { sections: SECTION, sections_url: window.location.pathname });

  /* ---------- rendering ---------- */
  function renderFromSections(sections) {
    const html = sections && sections[SECTION];
    const p = panel();
    if (!html || !p) return false;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const next = doc.querySelector('[data-sm-cart-panel]');
    if (!next) return false;
    const body = p.querySelector('[data-sm-cart-body]');
    const scrollTop = body ? body.scrollTop : 0;
    const giftsBefore = p.querySelectorAll('[data-sm-gifts] .g').length;
    const oldFill = p.querySelector('.ship .fill');
    const fillBefore = oldFill ? oldFill.style.width : null;
    [...next.attributes].forEach((a) => p.setAttribute(a.name, a.value));
    p.innerHTML = next.innerHTML;
    // Free-shipping bar: animate from the previous width (300ms, CSS) instead of jumping
    const nf = p.querySelector('.ship .fill');
    if (nf && fillBefore && nf.style.width !== fillBefore && !reduceMotion()) {
      const target = nf.style.width;
      nf.style.width = fillBefore;
      void nf.offsetWidth;
      requestAnimationFrame(() => { nf.style.width = target; });
    }
    const nb = p.querySelector('[data-sm-cart-body]');
    if (nb) nb.scrollTop = scrollTop;
    const g = p.querySelector('[data-sm-gifts]');
    if (g && g.querySelectorAll('.g').length > giftsBefore && giftsBefore > 0) g.classList.add('is-new');
    updateCount(p.dataset.bagCount || 0);
    document.dispatchEvent(new CustomEvent('sm:cart:updated', { detail: { state: p.dataset.state, total: +p.dataset.total } }));
    if (p.dataset.unlocked === 'true' && p.dataset.kind === 'otp' && !sessionStorage.getItem('sm_fs_unlocked')) {
      try { sessionStorage.setItem('sm_fs_unlocked', '1'); } catch (e) {}
      track('cart_free_shipping_unlocked', { value: +p.dataset.total / 100 });
    }
    return true;
  }

  async function refresh() {
    const res = await fetch(`${routes.root}${routes.root.endsWith('/') ? '' : '/'}?sections=${SECTION}`, { credentials: 'same-origin' });
    const data = await res.json();
    renderFromSections(data);
    return data;
  }

  async function get() {
    const cart = await request(routes.cartJs);
    st.lastCart = cart;
    return cart;
  }

  /* ---------- busy / errors ---------- */
  function setBusy(el, on) {
    const d = drawer();
    st.busy += on ? 1 : -1;
    if (st.busy < 0) st.busy = 0;
    if (d) d.classList.toggle('is-busy', st.busy > 0);
    if (!el) return;
    if (on) {
      el.setAttribute('aria-busy', 'true');
      if (el.classList.contains('btn') && !el.querySelector('.spin')) {
        const sp = document.createElement('span'); sp.className = 'spin'; sp.setAttribute('aria-hidden', 'true'); el.appendChild(sp);
      }
    } else {
      el.removeAttribute('aria-busy');
      const sp = el.querySelector(':scope > .spin'); if (sp) sp.remove();
    }
  }

  function showToast(message) {
    const p = panel();
    if (!p) return;
    clearTimeout(st.toastTimer);
    p.querySelectorAll('.toast').forEach((t) => t.remove());
    const slot = p.querySelector('[data-sm-toast-slot]');
    const t = document.createElement('div');
    t.className = 'toast';
    t.setAttribute('role', 'alert');
    const icon = document.createElement('span'); icon.className = 'ti'; icon.setAttribute('aria-hidden', 'true'); icon.textContent = '!';
    const msg = document.createElement('span'); msg.textContent = message;
    const dis = document.createElement('button'); dis.type = 'button'; dis.className = 'tx'; dis.textContent = p.dataset.dismiss || 'Dismiss';
    dis.addEventListener('click', () => t.remove());
    t.append(icon, msg, dis);
    if (slot) slot.appendChild(t);
    else { t.style.position = 'absolute'; t.style.bottom = 'calc(24px + env(safe-area-inset-bottom))'; p.appendChild(t); }
    st.toastTimer = setTimeout(() => t.remove(), 6000);
  }
  function errorMessage(err) {
    const p = panel();
    const generic = (p && p.dataset.errorText) || (C.strings && C.strings.cartError) || "Couldn't update your cart. Try again.";
    if (err && err.status === 422 && err.data && err.data.description) return err.data.description;
    return generic;
  }
  async function handleError(err) {
    track('cart_error', { status: err && err.status, message: err && err.message });
    try { await refresh(); } catch (e) { /* offline */ }
    showToast(errorMessage(err));
  }

  /* ---------- attribution (pre-lander -> checkout) ---------- */
  function captureParams() {
    try {
      const q = new URLSearchParams(window.location.search);
      const stored = JSON.parse(localStorage.getItem('sm_attr') || '{}');
      let changed = false;
      ATTR_KEYS.forEach((k) => { const v = q.get(k); if (v) { stored[k] = v; changed = true; } });
      if (changed) { stored.landing_page = window.location.pathname; localStorage.setItem('sm_attr', JSON.stringify(stored)); }
    } catch (e) {}
  }
  async function writeAttributes(cart) {
    let stored = {};
    try { stored = JSON.parse(localStorage.getItem('sm_attr') || '{}'); } catch (e) { return; }
    const keys = Object.keys(stored);
    if (!keys.length) return;
    const attrs = (cart && cart.attributes) || {};
    if (keys.every((k) => attrs[k] === stored[k])) return;
    try { await request(routes.cartUpdate, { attributes: stored }); } catch (e) { /* non-blocking */ }
  }

  /* ---------- core mutations ---------- */
  const planIdFor = (bags) => {
    const key = PLAN_BY_BAGS[Math.min(3, Math.max(1, bags))];
    return C.plans && C.plans[key] ? Number(C.plans[key]) : null;
  };
  const isGiftLine = (i) => i.properties && i.properties._welcome_kit;
  const productLines = (cart) => cart.items.filter((i) => String(i.variant_id) === String(C.variantId) && !isGiftLine(i));

  async function replaceLines(lines, bags, planId) {
    const updates = {};
    lines.forEach((l) => { updates[l.key] = 0; });
    if (lines.length) await request(routes.cartUpdate, { updates });
    const item = { id: Number(C.variantId), quantity: bags };
    if (planId) item.selling_plan = planId;
    return request(routes.cartAdd, withSections({ items: [item] }));
  }

  async function setOffer({ type, bags, cart }) {
    cart = cart || (await get());
    const planId = type === 'sub' ? planIdFor(bags) : null;
    const lines = productLines(cart);
    let data;
    if (lines.length === 1) {
      const line = lines[0];
      const body = withSections({ id: line.key, quantity: bags, selling_plan: planId || null });
      try {
        data = await request(routes.cartChange, body);
        const now = productLines(data);
        const nl = now[0];
        const planOk = planId
          ? nl && nl.selling_plan_allocation && Number(nl.selling_plan_allocation.selling_plan.id) === planId
          : nl && !nl.selling_plan_allocation;
        if (now.length !== 1 || !nl || nl.quantity !== bags || !planOk) data = await replaceLines(now, bags, planId);
      } catch (err) {
        if (err.status && err.status >= 500) throw err;
        data = await replaceLines([line], bags, planId); // change.js refused the plan swap: remove + add fallback
      }
    } else {
      data = await replaceLines(lines, bags, planId);
    }
    if (!renderFromSections(data && data.sections)) await refresh();
    return data;
  }

  const itemPayload = (type, bags) => ({
    item_id: String((C.analytics && C.analytics.itemId) || C.variantId),
    item_name: C.analytics && C.analytics.itemName,
    item_variant: type === 'sub' ? `Subscription ${bags}-bag` : 'One-time',
    quantity: bags,
  });

  function addOffer({ type = 'sub', bags = 3, opener = null, busyEl = null, keepOpen = false } = {}) {
    return enqueue(async () => {
      setBusy(busyEl, true);
      const fromState = panel() ? panel().dataset.state : null;
      try {
        const cart = await get();
        await writeAttributes(cart);
        const data = await setOffer({ type, bags, cart });
        const line = data && data.items ? productLines({ items: data.items })[0] : null;
        const value = line ? (line.final_line_price || line.line_price || 0) / 100 : undefined;
        track('add_to_cart', { currency: C.analytics && C.analytics.currency, value, items: [Object.assign(itemPayload(type, bags), { price: line ? line.final_price / 100 : undefined })] });
        if (keepOpen) {
          track('cart_upgrade_click', { from: fromState, to: panel() && panel().dataset.state });
          focusLine();
        } else {
          open(opener);
        }
        return data;
      } catch (err) {
        if (!keepOpen) open(opener);
        await handleError(err);
        throw err;
      } finally {
        setBusy(busyEl, false);
      }
    });
  }

  function mutate(url, body, busyEl, after) {
    return enqueue(async () => {
      setBusy(busyEl, true);
      try {
        const data = await request(url, withSections(body));
        if (!renderFromSections(data && data.sections)) await refresh();
        // The re-render replaces the pressed control: keep focus in the drawer on the line item (B5)
        if (st.open && panel() && panel().dataset.state !== 'G') focusLine();
        if (after) after(data);
        return data;
      } catch (err) {
        await handleError(err);
        throw err;
      } finally {
        setBusy(busyEl, false);
      }
    });
  }
  const add = (items, busyEl) => mutate(routes.cartAdd, { items }, busyEl);
  const change = (payload, busyEl) => mutate(routes.cartChange, payload, busyEl);
  const update = (payload, busyEl) => mutate(routes.cartUpdate, payload, busyEl);
  const remove = (key, busyEl) => mutate(routes.cartChange, { id: key, quantity: 0 }, busyEl, () => {
    track('remove_from_cart', { currency: C.analytics && C.analytics.currency });
    const p = panel(); if (p && p.dataset.state === 'G') { const x = p.querySelector('[data-sm-continue]') || p.querySelector('.x'); x && x.focus({ preventScroll: true }); }
  });

  /* ---------- open / close / focus ---------- */
  const focusables = (root) => [...root.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])')].filter((el) => el.offsetParent !== null || el === document.activeElement);
  function focusLine() {
    const p = panel(); if (!p) return;
    const target = p.querySelector('.item[data-line-key]') || p.querySelector('.hdr h2');
    if (target) { target.setAttribute('tabindex', '-1'); target.focus({ preventScroll: true }); }
  }

  // Page scroll restore on close (exact, no visible jump). Instant even if a stylesheet sets scroll-behavior: smooth.
  function scrollToInstant(y) {
    const html = document.documentElement;
    const prev = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';
    try { window.scrollTo({ top: y, left: 0, behavior: 'instant' }); } catch (e) { window.scrollTo(0, y); }
    if (Math.abs(window.scrollY - y) > 0.5) window.scrollTo(0, y);
    html.style.scrollBehavior = prev;
  }
  function holdScroll(y, frames) {
    requestAnimationFrame(() => {
      if (st.open) return;
      if (Math.abs(window.scrollY - y) > 0.5) scrollToInstant(y);
      if (frames > 1) holdScroll(y, frames - 1);
    });
  }
  function returnFocus() {
    const o = st.opener;
    if (o && typeof o.focus === 'function' && document.contains(o)) o.focus({ preventScroll: true });
  }

  function open(opener) {
    const d = drawer(); const p = panel();
    if (!d || !p) { window.location.href = routes.cart || '/cart'; return; }
    if (st.open) { p.focus({ preventScroll: true }); return; }
    st.opener = opener || document.activeElement;
    st.scrollY = window.scrollY || window.pageYOffset || 0;
    if (!document.documentElement.classList.contains('shopify-design-mode') && !window.Shopify?.designMode) {
      try {
        // Manual restoration while the drawer owns a history entry: going back to an entry whose URL has a hash
        // (#offer / #faq, written by the scroll CTAs) would otherwise scroll the page to that anchor on close.
        if ('scrollRestoration' in history) { st.restoration = history.scrollRestoration; history.scrollRestoration = 'manual'; }
        history.pushState({ smCart: true }, ''); st.histPushed = true;
      } catch (e) {}
    }
    document.documentElement.classList.add('sm-cart-open');
    document.body.style.top = `-${st.scrollY}px`;
    const wrap = pageWrap(); if (wrap) { wrap.inert = true; wrap.setAttribute('aria-hidden', 'true'); }
    d.classList.add('is-open');
    st.open = true;
    requestAnimationFrame(() => p.focus({ preventScroll: true }));
    document.dispatchEvent(new CustomEvent('sm:cart:open'));
    track('view_cart', { currency: C.analytics && C.analytics.currency, value: +p.dataset.total / 100 });
  }

  // Close: unlock the page, restore the exact scroll position instantly, then remove the history entry pushed on open.
  // The browser can move the page (and focus) while it traverses back, so scroll and focus are re-applied once the
  // traversal has settled (popstate) and checked again over the next frames.
  function close({ fromPop = false } = {}) {
    const d = drawer();
    if (!d || !st.open) return;
    const y = st.scrollY;
    d.classList.remove('is-open');
    st.open = false;
    document.documentElement.classList.remove('sm-cart-open');
    document.body.style.top = '';
    const wrap = pageWrap(); if (wrap) { wrap.inert = false; wrap.removeAttribute('aria-hidden'); }
    scrollToInstant(y);
    returnFocus();
    const settle = () => {
      if (st.open) return;
      scrollToInstant(y);
      returnFocus();
      holdScroll(y, 3);
      if (st.restoration) { const r = st.restoration; st.restoration = null; setTimeout(() => { if (!st.histPushed) { try { history.scrollRestoration = r; } catch (e) {} } }, 50); }
    };
    if (st.histPushed && !fromPop) {
      st.histPushed = false;
      let settled = false;
      const onPop = () => { window.removeEventListener('popstate', onPop); settled = true; settle(); };
      window.addEventListener('popstate', onPop);
      setTimeout(() => { if (!settled) { window.removeEventListener('popstate', onPop); settle(); } }, 1000); // popstate never came
      try { history.back(); } catch (e) { onPop(); }
    } else {
      st.histPushed = false;
      settle();
    }
    document.dispatchEvent(new CustomEvent('sm:cart:close'));
  }

  /* ---------- drawer interactions (delegated) ---------- */
  function selectQtyRow(row) {
    const group = row.closest('[data-sm-qty-group]'); if (!group) return;
    group.querySelectorAll('.qr').forEach((r) => {
      const on = r === row;
      r.classList.toggle('sel', on); r.setAttribute('aria-checked', on ? 'true' : 'false'); r.tabIndex = on ? 0 : -1;
    });
    const btn = group.parentElement.querySelector('[data-sm-action="qty-add"]');
    if (btn) {
      const delta = +row.dataset.delta;
      btn.dataset.bags = row.dataset.bags;
      const tpl = delta === 1 ? btn.dataset.labelOne : btn.dataset.labelMany;
      const label = btn.querySelector('[data-sm-qty-label]');
      if (label) label.textContent = tpl.replace('[n]', delta);
    }
  }

  function onDrawerClick(e) {
    const t = e.target;
    if (t.closest('[data-sm-cart-close]')) { e.preventDefault(); close(); return; }
    const cont = t.closest('[data-sm-continue]');
    if (cont) {
      if (document.querySelector('[data-sm-offer]')) { e.preventDefault(); close(); }
      return;
    }
    const co = t.closest('[data-sm-checkout]');
    if (co) {
      const p = panel();
      track('begin_checkout', { currency: C.analytics && C.analytics.currency, value: p ? +p.dataset.total / 100 : undefined });
      if (st.busy > 0) { e.preventDefault(); chain.then(() => { window.location.href = co.href; }); }
      setBusy(co, true);
      return;
    }
    const act = t.closest('[data-sm-action]');
    if (!act || act.disabled || act.getAttribute('aria-disabled') === 'true') return;
    const kind = act.dataset.smAction;
    if (kind === 'remove') { e.preventDefault(); remove(act.dataset.key, act).catch(() => {}); }
    else if (kind === 'qty') { e.preventDefault(); stepQty(act); }
    else if (kind === 'upgrade') { e.preventDefault(); addOffer({ type: 'sub', bags: +act.dataset.bags, busyEl: act, keepOpen: true }).catch(() => {}); }
    else if (kind === 'qty-row') { e.preventDefault(); selectQtyRow(act); track('cart_quantity_break_click', { bags: +act.dataset.bags }); }
    else if (kind === 'qty-add') { e.preventDefault(); addOffer({ type: 'otp', bags: +act.dataset.bags, busyEl: act, keepOpen: true }).catch(() => {}); }
  }

  // Stepper: optimistic count, 250ms debounce, only the final quantity is sent (B2). Quantity 0 removes the line.
  function stepQty(btn) {
    const key = btn.dataset.key;
    const step = btn.closest('.step');
    const countEl = step && step.querySelector('i');
    const target = Math.max(0, +btn.dataset.qty);
    if (countEl) countEl.textContent = target;
    step && step.querySelectorAll('[data-sm-action="qty"]').forEach((b, i) => {
      b.dataset.qty = i === 0 ? target - 1 : target + 1;
      if (i === 0) { b.disabled = target <= 1; b.classList.toggle('dis', target <= 1); } // minus is disabled at 1
    });
    clearTimeout(st.qtyTimers[key]);
    st.qtyTimers[key] = setTimeout(() => {
      const before = st.lastCart && st.lastCart.items ? (st.lastCart.items.find((i) => i.key === key) || {}).quantity : null;
      change({ id: key, quantity: target }, btn).then(() => {
        if (before != null) track(target > before ? 'add_to_cart' : 'remove_from_cart', { currency: C.analytics && C.analytics.currency, items: [{ item_id: String(C.variantId), quantity: Math.abs(target - before) }] });
      }).catch(() => {});
    }, 250);
  }

  function onDrawerKeydown(e) {
    if (!st.open) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    const row = e.target.closest && e.target.closest('.qr[role="radio"]');
    if (row) {
      const rows = [...row.parentElement.querySelectorAll('.qr:not(.dis)')];
      const i = rows.indexOf(row);
      let next = null;
      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') next = rows[(i + 1) % rows.length];
      if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') next = rows[(i - 1 + rows.length) % rows.length];
      if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); selectQtyRow(row); return; }
      if (next) { e.preventDefault(); selectQtyRow(next); next.focus(); return; }
    }
    if (e.key === 'Tab') {
      const p = panel(); const f = focusables(p);
      if (!f.length) { e.preventDefault(); p.focus(); return; }
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === p)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  /* ---------- pre-lander CTA mode 3: data-sm-cta="add" data-plan="90|60|30|otp3|otp2|otp1" ---------- */
  const CTA_PLANS = { '90': ['sub', 3], '60': ['sub', 2], '30': ['sub', 1], otp3: ['otp', 3], otp2: ['otp', 2], otp1: ['otp', 1] };
  async function onCtaAdd(el) {
    const cfg = CTA_PLANS[el.dataset.plan] || CTA_PLANS['90'];
    const code = el.dataset.discount;
    if (code) { try { await fetch(`/discount/${encodeURIComponent(code)}`, { credentials: 'same-origin' }); } catch (e) {} }
    return addOffer({ type: cfg[0], bags: cfg[1], opener: el, busyEl: el });
  }

  /* ---------- wiring ---------- */
  // Pre-lander CTA mode 1 links keep UTM / click ids (12-prelander-system 3).
  function carryParams() {
    const q = new URLSearchParams(window.location.search);
    const keep = ATTR_KEYS.filter((k) => q.get(k));
    if (!keep.length) return;
    document.querySelectorAll('a[data-sm-cta="pdp"]').forEach((a) => {
      try {
        const u = new URL(a.getAttribute('href'), window.location.origin);
        if (u.pathname.startsWith('/discount/') && u.searchParams.get('redirect')) {
          const r = new URL(u.searchParams.get('redirect'), window.location.origin);
          keep.forEach((k) => r.searchParams.set(k, q.get(k)));
          u.searchParams.set('redirect', r.pathname + r.search);
        } else {
          keep.forEach((k) => u.searchParams.set(k, q.get(k)));
        }
        a.setAttribute('href', u.pathname + u.search + u.hash);
      } catch (e) {}
    });
  }

  function bind() {
    captureParams();
    carryParams();
    document.addEventListener('click', (e) => {
      const d = drawer();
      if (d && d.contains(e.target)) { onDrawerClick(e); return; }
      const opener = e.target.closest('[data-sm-cart-open], a[href="/cart"], a[href$="/cart"]:not([href*="/cart/"])');
      if (opener && drawer()) { e.preventDefault(); open(opener); return; }
      const cta = e.target.closest('[data-sm-cta="add"]');
      if (cta) { e.preventDefault(); onCtaAdd(cta).catch(() => {}); }
    });
    document.addEventListener('keydown', (e) => { if (st.open) onDrawerKeydown(e); });
    window.addEventListener('popstate', () => { if (st.open) close({ fromPop: true }); });
    window.addEventListener('pageshow', (e) => { if (e.persisted) refresh().catch(() => {}); });
    window.addEventListener('online', () => { if (!st.busy) refresh().catch(() => {}); }); // resync after an offline error
    document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible' && !st.busy && !st.open) refresh().catch(() => {}); });
    document.addEventListener('shopify:section:load', (e) => { if (e.target && e.target.querySelector && e.target.querySelector('[data-sm-cart-drawer]')) { st.open = false; } });
    const p = panel();
    if (p) updateCount(p.dataset.bagCount || 0);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind); else bind();

  window.SMCart = { get, add, change, update, remove, refresh, open, close, addOffer, setOffer: (o) => addOffer(Object.assign({ keepOpen: true }, o)), prefetch: () => { fetch(routes.cartJs, { credentials: 'same-origin' }).catch(() => {}); }, renderFromSections };
})();
